import { AlarmAcquisitionResult } from './AlarmNotificationReconciler';

export class AlarmAcquisitionCompletion {
	private readonly completion: Promise<AlarmAcquisitionResult>;
	private rejectCompletion!: (reason?: unknown) => void;
	private resolveCompletion!: (result: AlarmAcquisitionResult) => void;
	private started = false;

	public constructor() {
		this.completion = new Promise<AlarmAcquisitionResult>((resolve, reject) => {
			this.resolveCompletion = resolve;
			this.rejectCompletion = reject;
		});
		void this.completion.catch(() => undefined);
	}

	public hasStarted(): boolean {
		return this.started;
	}

	public markStarted(): void {
		this.started = true;
	}

	public reject(reason: unknown): void {
		this.rejectCompletion(reason);
	}

	public resolve(result: AlarmAcquisitionResult): void {
		this.resolveCompletion(result);
	}

	public wait(): Promise<AlarmAcquisitionResult> {
		return this.completion;
	}
}
